module.exports = __webpack_public_path__ + "static/eggs-29f765115901e81d700e7b1f31885f21.jpg";